export const MapperFields = {
    NAME: 'name',
    SKU: 'sku',
    SKU_FROM_API: 'sku_from_api',
    PARENT_SKU: 'parentSku',
    EXTERNAL_ID: 'externalId',
    BARCODE: 'barcode',
    DESCRIPTION: 'description',
    DESCRIPTION_SHORT: 'descriptionShort',
    ADDITIONAL_DESCRIPTION: 'additionalDescription',
    BRAND: 'brand',
    CATEGORIES: 'categories',
    GENDER: 'gender',
    WEIGHT: 'weight',
    CURRENCY: 'currency',
    STATUS: 'status',
    PRICE: 'price',
    URL: 'url',
    UPC: 'upc',
    PICTURES: 'pictures',
    OUTLET_PRICE: 'outletPrice',
    DISCOUNTED_PRICE: 'discountedPrice',
    PROMOTIONS: 'promotions',
    ECO_TAX: 'ecoTax',
    TAX_RATE: 'taxRate',
    SOLD_PHYSICALLY: 'soldPhysically',
    LOCALE: 'locale',
    MANUFACTURER_NAME: 'manufacturerName',
    MANUFACTURER_DESCRIPTION: 'manufacturerDescription',
    MANUFACTURER_ADDRESS: 'manufacturerAddresses',
    TAGS: 'tags',
    EAN: 'ean',
    CORNER: 'corner',
    CATALOG_ONLY: 'catalogOnly',
    PRIVATE_PRICE: 'privatePrice',
    PRIVATE_PRODUCT: 'privateProduct',
    HIDDEN_PRICE: 'hiddenPrice',
    CHANNELS: 'channel',
    STOCK_UPDATED_AT_DATE: 'stockUpdatedAtDate',
}

export const MapperPrefixCode = {
    ATTRIBUTE: 'attr_',
    INVENTORY: 'stock_',
    OPTION_VALUE_MAPPING: 'mapping_value_',
}

export function getAllMapperFields(options) {
    const allFields = [];

    for (const field in MapperFields) {
        allFields.push(MapperFields[field]);
    }

    options.forEach((option) => {
        allFields.push(option.id);
        if (option.mapped) {
            allFields.push(MapperPrefixCode.OPTION_VALUE_MAPPING + option.id);
        }
    });

    return allFields;
}

export function getMerchandisingMapperFields() {
    return [
        MapperFields.SKU,
        MapperFields.PARENT_SKU,
        MapperFields.BARCODE,
        MapperFields.DESCRIPTION,
        MapperFields.ADDITIONAL_DESCRIPTION,
        MapperFields.PICTURES,
        MapperFields.NAME,
        MapperFields.BRAND
    ]
}

export function getCharacteristicsMapperFields(options) {
    const characteristicsMapperFields = [
        MapperFields.CATEGORIES,
        MapperFields.CORNER,
        MapperFields.GENDER,
    ];

    options.forEach((option) => {
        characteristicsMapperFields.push(option.id);
        if (option.mapped) {
            characteristicsMapperFields.push(MapperPrefixCode.OPTION_VALUE_MAPPING + option.id);
        }
    });

    characteristicsMapperFields.push(MapperFields.WEIGHT);

    return characteristicsMapperFields;
}

export function getStocksAndStatusMapperFields() {
    return [
        MapperFields.STATUS,
        MapperFields.STOCK_UPDATED_AT_DATE,
    ]
}

export function getPricesAndPromotionsMapperFields() {
    return [
        MapperFields.PRICE,
        MapperFields.OUTLET_PRICE,
        MapperFields.DISCOUNTED_PRICE,
        MapperFields.PROMOTIONS,
        MapperFields.ECO_TAX,
    ]
}

export function getOptionsMapperFields() {
    return [
        MapperFields.SOLD_PHYSICALLY,
        MapperFields.URL,
        MapperFields.EXTERNAL_ID,
        MapperFields.LOCALE,
        MapperFields.CURRENCY,
        MapperFields.TAX_RATE,
        MapperFields.CATALOG_ONLY,
        MapperFields.PRIVATE_PRICE,
        MapperFields.PRIVATE_PRODUCT,
        MapperFields.HIDDEN_PRICE,
        MapperFields.CHANNELS
    ]
}

export function getStockFeedMapperFields() {
    return [
        MapperFields.SKU,
        MapperFields.STATUS,
        MapperFields.STOCK_UPDATED_AT_DATE,
    ]
}
export function getAdditionalMapperFieldsNamesFromConfiguration(configurationMapperFields, options) {
    const configurationMapperFieldNames = [];

    Object.keys(configurationMapperFields).forEach((fieldName) => {
        if (!getAllMapperFields(options).includes(fieldName) && !fieldName.startsWith(MapperPrefixCode.INVENTORY)) {
            configurationMapperFieldNames.push(fieldName)
        }
    });

    return configurationMapperFieldNames
}

export function getInventoryMapperFieldsNamesFromConfiguration(configurationMapperFields) {
    const configurationMapperFieldNames = [];

    Object.keys(configurationMapperFields).forEach((fieldName) => {
        if (fieldName.indexOf(MapperPrefixCode.INVENTORY) !== -1) {
            configurationMapperFieldNames.push(fieldName)
        }
    });

    return configurationMapperFieldNames
}

export function getProductFields() {
    return [
        MapperFields.NAME,
        MapperFields.EXTERNAL_ID,
        MapperFields.DESCRIPTION,
        MapperFields.CATEGORIES,
        MapperFields.BRAND,
        MapperFields.GENDER,
        MapperFields.CURRENCY,
        MapperFields.TAX_RATE,
        MapperFields.WEIGHT,
        MapperFields.PICTURES
    ]
}
